module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Copyright, 1918, by")]), _c('br'), _vm._v("\nD. APPLETON AND COMPANY"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Copyright, 1918, by The Frank A. Munsey Company")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\nPrinted in the United States of America")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76dcaf1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3186253215635795556_74210-h-3.htm.vue
// module id = 66
// module chunks = 0